import { ConditionalProperties } from 'Automations/nodeDefinitions/conditions'
import { Condition } from '../..'

export const areAllConditionsExhausted = ({
  conditions,
  allProperties
}: {
  conditions: Condition[]
  allProperties: ConditionalProperties
}): boolean => {
  const totalOperatorSlots = Object.values(allProperties).reduce(
    (sum, property) => sum + Object.keys(property.operators).length,
    0
  )

  return conditions.length >= totalOperatorSlots
}
